import React, { useState } from "react";
import TextInput from "common/TextInput";

const AskTag = ({ address, onChange, onApply, disabled = false }) => (
  <TextInput
    type="text"
    name="address"
    label="Add this IP address range to bypass:"
    className="input-control align-right"
    defaultValue={address}
    onChange={onChange}
    disabled={disabled}
    placeholder="1.1.1.1/24"
    addon={
      <i className="material-icons actions-icon-color action shaded" onClick={onApply}>add</i>
    }
  />
);

const doesNothing = () => {};

const CreateIPRange = ({ doValidate = doesNothing, doSave = doesNothing, bqn }) => {
  const [range, setIPRange] = useState({ address: "" });
  const [error, setError] = useState(null);
  const handleChange = (event) => {
    try {
      const address = event.target.value;
      const range = { address };
      doValidate(range);
      setError(null);
      setIPRange(range);
    } catch (error) {
      setError(error);
    }
  };

  const doApply = () => {
    try {
      doValidate(range);
      doSave(range);
    } catch (error) {
      setError(error);
    }
  };

  const onApply = () => {
    if (bqn === "all") {
      showModalConfirm(
        "Create address for all BQN's?",
        "The address will be added for all BQN's in the cluster when Applied, please use the other tabs if you want to add just for specific BQNs.",
        "warning",
        () => doApply(),
        () => null,
        "OK",
        "CANCEL",
      );
    } else {
      doApply();
    }
  };

  return (
    <>
      <div>
        <AskTag
          address={range.address}
          onChange={handleChange}
          onApply={onApply}
          error={error}
        />
      </div>
      {error !== null && (
        <div className="modal-err-msg color-red align-left">{error}</div>
      )}
    </>
  );
};
export default CreateIPRange;
